module.exports = __webpack_public_path__ + "static/media/all.6fa83788.svg";